// custom-loading.js
import Vue from 'vue';

// 定義自定義指令 v-custom-loading
Vue.directive('custom-loading', {
  bind(el, binding) {
    const originalDisplay = window.getComputedStyle(el).display;
    el.style.position = 'relative';
    el.style.overflow = 'hidden';

    const loadingWrapper = document.createElement('div');
    loadingWrapper.className = 'custom-loading-wrapper';
    loadingWrapper.style.position = 'absolute';
    loadingWrapper.style.zIndex = '2000';
    loadingWrapper.style.backgroundColor = 'white';
    loadingWrapper.style.margin = '0';
    loadingWrapper.style.top = '0';
    loadingWrapper.style.right = '0';
    loadingWrapper.style.bottom = '0';
    loadingWrapper.style.left = '0';
    el.appendChild(loadingWrapper);

    const loadingElement = document.createElement('div');
    loadingElement.className = 'custom-loading';
    loadingElement.style.position = 'absolute';
    loadingElement.style.top = '50%';
    loadingElement.style.marginTop = '-21px';
    loadingElement.style.width = '100%';
    loadingElement.style.textAlign = 'center';
    loadingWrapper.appendChild(loadingElement);

    // 插入 SVG 圖示
    // 插入 SVG 圖示
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '42');
    svg.setAttribute('height', '42');
    svg.innerHTML = '<circle cx="21" cy="21" r="18" stroke="#333" stroke-width="4" fill="none" />';
    loadingElement.appendChild(svg);


    el.showLoading = function() {
      loadingWrapper.style.display = 'block';
      // el.style.display = 'none';
    };

    el.hideLoading = function() {
      loadingWrapper.style.display = 'none';
      el.style.display = originalDisplay;
    };
  },
  update(el, binding) {
    if (binding.value) {
      el.showLoading();
    } else {
      el.hideLoading();
    }
  }
});
